import { Button, Flex, Menu, MenuButton, MenuDivider, MenuGroup, MenuItem, MenuList, Spinner } from '@chakra-ui/react';

import { ChevronDownIcon, ExportIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';
import { TextBold } from '@components/typography';

import styles from './styles.module.css';
import { useMutateExportSellout } from '@pages/SelloutMonitoring/hooks/mutate/useExportSellout';
import { useFilter } from '@pages/SelloutMonitoring/hooks/state/filters';
import { useGlobalFilter } from '@pages/SelloutMonitoring/hooks/state/globalFilter';

const Export = () => {
    const localFilter = useFilter();
    const globalFilter = useGlobalFilter();
    const { mutate, isPending } = useMutateExportSellout();

    const exportOption = (type) => () => {
        localFilter.setFilter({ type });
        if (type === 'csv') {
            mutate({ type, ...localFilter, ...globalFilter });
        } else {
            mutate({ type, ...localFilter, ...globalFilter });
        }
    };

    return (
        <Menu matchWidth>
            {({ isOpen }) => (
                <>
                    <MenuButton
                        as={Button}
                        disabled={isPending}
                        variant="outline"
                        borderColor="var(--color-border-grey1)"
                        borderRadius="4px"
                        rightIcon={
                            <div className={`${styles.rightIcon} ${isOpen ? styles.open : ''}`}>
                                <ChevronDownIcon />
                            </div>
                        }
                    >
                        <Flex gap="8px" alignItems="center">
                            <div className={styles.icon_container}>
                                <ConditionalComponent statement={!isPending} fallback={<Spinner speed="1s" />}>
                                    <ExportIcon />
                                </ConditionalComponent>
                            </div>
                            <TextBold>Export Data</TextBold>
                        </Flex>
                    </MenuButton>
                    <MenuList minWidth="unset" padding="0" overflow="clip" borderColor={'neutral.200'} zIndex={10}>
                        <MenuGroup>
                            <MenuItem padding="12px" onClick={exportOption('xlsx')}>
                                Export as XLSX
                            </MenuItem>
                            <MenuDivider margin="0" borderColor="neutral.200" opacity={1} />
                            <MenuItem padding="12px" onClick={exportOption('csv')}>
                                Export as CSV
                            </MenuItem>
                        </MenuGroup>
                    </MenuList>
                </>
            )}
        </Menu>
    );
};

export default Export;
